import Vue from 'vue';
import Vuex from 'vuex';

// eslint-disable-next-line import/no-cycle
import auth from '@/store/modules/auth';
// eslint-disable-next-line import/no-cycle
import user from '@/store/modules/user/user';
import community from '@/store/community';
import feed from '@/store/feed';
import posts from '@/store/posts';
import sections from '@/store/modules/sections';
// eslint-disable-next-line import/no-cycle
import content from '@/store/content';
import admin from '@/store/modules/admin/index';
import contact from '@/store/contact';
// eslint-disable-next-line import/no-cycle
import payment from '@/store/modules/payment';
import errorOverlay from '@/store/error';
import successOverlay from '@/store/success';
import profile from '@/store/modules/profile';
import analytics from '@/store/modules/analytics';
import dashboard from '@/store/modules/dashboard';
import homepage from '@/store/modules/homepage';
import mainSearch from '@/store/modules/mainSearch';
import csv from '@/store/modules/csv';
import extras from '@/store/modules/extras/index';
import comments from '@/store/modules/comments';
import editor from '@/store/editor';
import school from '@/store/modules/school';
import menu from '@/store/menu';
import widgets from '@/store/widgets';
import dashboardAside from '@/store/dashboard-aside';
import profileDesignSettings from '@/store/profile-design-settings';
import previewScreenWidgets from '@/store/preview-screen-widgets';
// eslint-disable-next-line import/no-cycle
import upgradePopup from '@/store/upgrade-popup';
import paidTier from '@/store/paid-tier';

import {
  sendCompleteJoinRequest,
  getJoinRequest,
} from '@/api/auth';

Vue.use(Vuex);

const defaultState = {
  isInitialized: false,
  request: null,
  signUpEmail: null,
  utmMarks: null,
};

export default new Vuex.Store({
  modules: {
    auth,
    user,
    feed,
    posts,
    community,
    sections,
    content,
    admin,
    contact,
    payment,
    errorOverlay,
    successOverlay,
    profile,
    analytics,
    dashboard,
    homepage,
    mainSearch,
    csv,
    extras,
    comments,
    editor,
    menu,
    widgets,
    school,
    dashboardAside,
    profileDesignSettings,
    previewScreenWidgets,
    upgradePopup,
    paidTier,
  },
  state: defaultState,
  mutations: {
    resetState(state) {
      Object.assign(state, defaultState, { user: {} });
    },
    setJoinRequest(state, { request }) {
      state.request = request;
    },
    setInitialized(state, status) {
      state.isInitialized = status;
    },
    setSignUpEmail(state, email) {
      state.signUpEmail = email;
    },
    setUtmMarks(state, marks) {
      state.utmMarks = marks;
    },
  },
  actions: {
    resetState() {
      this.commit('resetState');
    },
    async loadJoinRequest({ commit, dispatch }, { token }) {
      try {
        const { data } = await getJoinRequest(token);
        commit('setJoinRequest', { request: data });
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      }
    },
    async completeJoinRequest({ commit }, { claimToken, password }) {
      try {
        const { data } = await sendCompleteJoinRequest({ claimToken, password });
        commit('user/setUser', data.data);
        commit('user/setToken', data.token);
      } catch (err) {
        throw err;
      }
    },
    storeUtmMarks({ commit }, payload) {
      try {
        const utmKeys = Object.keys(payload).filter(mark => mark.includes('utm_'));
        if (!utmKeys.length) return;
        const utmMarks = utmKeys.reduce((acc, key) => {
          acc[key] = payload[key];
          return acc;
        }, {});
        commit('setUtmMarks', utmMarks);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    signUpEmail: state => state.signUpEmail,
    joinRequest: state => state.request,
    isInitialized: state => state.isInitialized,
    developmentMode: () => process.env.NODE_ENV === 'development',
    utmMarks: state => state.utmMarks,
  },
});
